module.exports = __webpack_public_path__ + "static/img/spcs.691e4d46.png";